import { render } from "./FuzzyMatchModal.vue?vue&type=template&id=1963d3a5&scoped=true"
import script from "./FuzzyMatchModal.vue?vue&type=script&lang=js"
export * from "./FuzzyMatchModal.vue?vue&type=script&lang=js"

import "./FuzzyMatchModal.vue?vue&type=style&index=0&id=1963d3a5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1963d3a5"]])

export default __exports__